export enum AcknowledgementOption {
    never = 'Never',
    onRequest = 'OnRequest',
    always = 'Always',
}

export const acknowledgementOptions = [
    { value: AcknowledgementOption.never, name: 'Never' },
    { value: AcknowledgementOption.onRequest, name: 'On request' },
    { value: AcknowledgementOption.always, name: 'Always' },
];
